import {Controller} from "@hotwired/stimulus"
import {post} from "@rails/request.js"

export default class extends Controller {
  static targets = ["askCancelButton", "dialog", "checkbox", "question", "submitButton"];

  connect() {
    console.debug("Schedules Batch Actions connected");
    this.modal = bootstrap.Modal.getOrCreateInstance(this.dialogTarget, {
      backdrop: 'static',
      keyboard: false
    });

    this.selectedSchedules = [];
  }

  disconnect() {
    console.debug("Schedules Batch Actions disconnected");
  }

  open(e) {
    if (!this.modal.isOpened) {
      this.modal.show();
    }
  }

  hide() {
    this.modal.hide();
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide();
    }
  }

  askPermission(event) {
    console.debug(event, this.dialogTarget);
    this.questionTarget.innerHTML = `
      Deseas cancelar las ${this.selectedSchedules.length} clases seleccionadas?
    `
    this.open();
  }

  checkboxChanged(event) {
    console.warn("CB ", this.extractSelectedSchedules());

    const selected = this.selectedSchedules;

    if (selected.length > 0) {
      this.askCancelButtonTarget.removeAttribute("disabled");
      return;
    }

    this.askCancelButtonTarget.setAttribute("disabled", "disabled");
  }

  submit(event) {
    console.warn("SEND =>", this.selectedSchedules);

    this.submitButtonTarget.setAttribute("disabled", "disabled");
    this.submitButtonTarget.children[1].textContent = "Cancelando clases seleccionadas...";

    post(`/schedules/cancel_many`, {
        responseKind: "turbo_stream",
        body: {
          schedule_ids: this.selectedSchedules,
        }
      }
    ).then(response => {
      console.debug("CANCEL MANY RESPONSE", response);

      this.submitButtonTarget.children[1].textContent = "Cancelar clases seleccionadas";
      this.submitButtonTarget.removeAttribute("disabled");

      if (response.ok) {
        this.hide();
      }

      return response;
    })
  }

  extractSelectedSchedules() {
    const scheduleIds = [];
    for (const checkboxTarget of this.checkboxTargets) {
      if (checkboxTarget.checked) {
        scheduleIds.push(checkboxTarget.value);
      }
    }

    this.selectedSchedules = scheduleIds;
  }
}
